import { useState } from "react";

import { FileThumbnail } from "../FileThumbnail";
import { getFileSizeFromBase64 } from "../../utils";
import { DetectedFile } from "../../types";

interface ImageThumbnailProps {
  dataUrl: string;
  detectedFile: DetectedFile;
  data: string;
  onClick?: () => void;
}

const MAX_EXTENSION_LENGTH = 100;

const getExtension = (detectedFile: DetectedFile) => {
  if (detectedFile.extension && detectedFile.extension.length > MAX_EXTENSION_LENGTH) {
    return detectedFile.extension.split(";")[0].split("/")[1].toUpperCase();
  }

  if (detectedFile.mimeType) {
    return detectedFile.mimeType.split("/")[1].toUpperCase();
  }

  return detectedFile.extension?.toUpperCase() || "IMG";
};

export const ImageThumbnail = ({ dataUrl, detectedFile, data, onClick }: ImageThumbnailProps) => {
  const [imageError, setImageError] = useState(false);

  if (imageError) {
    return (
      <FileThumbnail
        title="Image File"
        subtitle={`${
          detectedFile.extension?.toUpperCase() || "IMG"
        } • ${getFileSizeFromBase64(data)}`}
        error
        onClick={onClick}
      />
    );
  }

  return (
    <div className="flex cursor-pointer items-center gap-3" onClick={onClick}>
      <img
        src={dataUrl}
        className="h-12 w-12 rounded object-cover"
        onError={() => setImageError(true)}
        alt="file preview"
      />
      <div className="flex-1">
        <div className="text-sm font-medium text-gray-900">Image File</div>
        <div className="text-xs text-gray-500">
          {getExtension(detectedFile)} • {getFileSizeFromBase64(data)}
        </div>
      </div>
    </div>
  );
};
